export const getCurrentLocation = () => new Promise((resolve, reject) => {
  navigator.geolocation.getCurrentPosition(({ coords })=>resolve(coords), reject);
});
